<template>
  <div>
    <div class="anamnese-title">
      <span>2/5</span>
      <h4>{{ answers.two.name }}</h4>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>A (1). {{ answers.two.a1.question }}</h4>
            <div
              v-if="answers.two.a1.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.two.a1.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>

      <ul>
        <li :class="answers.two.a1.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'a1', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.two.a1.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'a1', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.two.a1.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>A (2). {{ answers.two.a2.question }}</h4>
            <div
              v-if="answers.two.a2.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.two.a2.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.two.a2.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'a2', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.two.a2.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'a2', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.two.a2.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>A (3). {{ answers.two.a3.question }}</h4>
            <div
              v-if="answers.two.a3.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.two.a3.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>

      <ul>
        <li :class="answers.two.a3.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'a3', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.two.a3.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'a3', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.two.a3.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>B. {{ answers.two.b.question }}</h4>
            <div
              v-if="answers.two.b.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.two.b.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.two.b.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'b', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.two.b.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'b', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.two.b.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>C. {{ answers.two.c.question }}</h4>
            <div
              v-if="answers.two.c.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.two.c.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>

      <ul>
        <li :class="answers.two.c.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'c', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.two.c.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('two', 'c', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.two.c.explanation"
      ></textarea>
    </div>
  </div>
</template>

<script>
import useAnswers from "../../composables/useAnswers.js";

export default {
  components: {},
  setup() {
    const { answers } = useAnswers();

    const onClickBoolean = (question, letter, answer) => {
      if (answers.value[question][letter].answer == answer) {
        answers.value[question][letter].answer = "";
      } else {
        answers.value[question][letter].answer = answer;
      }
    };

    return { answers, onClickBoolean };
  },
};
</script>

<style scoped>
@media (min-width: 991px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 225px;
  }
}
@media (min-width: 1442px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 300px;
  }
}
</style>
